"use strict";
exports.__esModule = true;
exports.getOpponent = void 0;
var getOpponent = function (index) { return (index === 1 ? 2 : 1); };
exports.getOpponent = getOpponent;
